import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Services from "@/pages/Services";

export const Route = createFileRoute("/_site/services/")({
  head: () => ({
    ...seo({
      title: "Roofing & Exterior Services | Kodiak Structures & Exteriors",
      description:
        "Expert roofing, siding, windows, and gutter services throughout Minnesota. Kodiak Structures & Exteriors — built to last.",
      path: "/services",
    }),
  }),
  component: Services,
});
